var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar-wrapper",style:({
    top: _vm.realTop,
    opacity: _vm.value >= 100 ? 1 : 1,
  })},[_c('div',{staticClass:"progress-bar-container"},[_c('div',{staticClass:"progress-bar-value",style:({
        width: _vm.realPercent,
        height: _vm.realSize,
        background: _vm.realColor,
        'transition-property': 'width',
        'transition-delay': _vm.delay,
        'transition-duration': _vm.duration,
        'transition-timing-function': _vm.timing,
      })})])])}
var staticRenderFns = []

export { render, staticRenderFns }